import Endpoints = require("../Endpoints");
import Constants = require("../Constants");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	APIGuildMember,
	APIGuildWidget,
	RESTDeleteAPIGuildBanResult,
	RESTDeleteAPIGuildIntegrationResult,
	RESTDeleteAPIGuildMemberResult,
	RESTDeleteAPIGuildMemberRoleResult,
	RESTDeleteAPIGuildResult,
	RESTDeleteAPIGuildRoleResult,
	RESTGetAPIGuildBanResult,
	RESTGetAPIGuildBansQuery,
	RESTGetAPIGuildBansResult,
	RESTGetAPIGuildChannelsResult,
	RESTGetAPIGuildIntegrationsResult,
	RESTGetAPIGuildInvitesResult,
	RESTGetAPIGuildMemberResult,
	RESTGetAPIGuildMembersQuery,
	RESTGetAPIGuildMembersResult,
	RESTGetAPIGuildMembersSearchQuery,
	RESTGetAPIGuildMembersSearchResult,
	RESTGetAPIGuildPreviewResult,
	RESTGetAPIGuildPruneCountQuery,
	RESTGetAPIGuildPruneCountResult,
	RESTGetAPIGuildResult,
	RESTGetAPIGuildRolesResult,
	RESTGetAPIGuildThreadsResult,
	RESTGetAPIGuildVanityUrlResult,
	RESTGetAPIGuildVoiceRegionsResult,
	RESTGetAPIGuildWelcomeScreenResult,
	RESTGetAPIGuildWidgetSettingsResult,
	RESTPatchAPICurrentGuildMemberJSONBody,
	RESTPatchAPIGuildChannelPositionsJSONBody,
	RESTPatchAPIGuildChannelPositionsResult,
	RESTPatchAPIGuildJSONBody,
	RESTPatchAPIGuildMemberJSONBody,
	RESTPatchAPIGuildMemberResult,
	RESTPatchAPIGuildResult,
	RESTPatchAPIGuildRoleJSONBody,
	RESTPatchAPIGuildRolePositionsJSONBody,
	RESTPatchAPIGuildRolePositionsResult,
	RESTPatchAPIGuildRoleResult,
	RESTPatchAPIGuildVoiceStateCurrentMemberJSONBody,
	RESTPatchAPIGuildVoiceStateCurrentMemberResult,
	RESTPatchAPIGuildVoiceStateUserJSONBody,
	RESTPatchAPIGuildVoiceStateUserResult,
	RESTPatchAPIGuildWelcomeScreenJSONBody,
	RESTPatchAPIGuildWelcomeScreenResult,
	RESTPatchAPIGuildWidgetSettingsJSONBody,
	RESTPatchAPIGuildWidgetSettingsResult,
	RESTPostAPIGuildChannelJSONBody,
	RESTPostAPIGuildChannelResult,
	RESTPostAPIGuildPruneJSONBody,
	RESTPostAPIGuildPruneResult,
	RESTPostAPIGuildRoleJSONBody,
	RESTPostAPIGuildRoleResult,
	RESTPutAPIGuildBanJSONBody,
	RESTPutAPIGuildBanResult,
	RESTPutAPIGuildMemberJSONBody,
	RESTPutAPIGuildMemberResult,
	RESTPutAPIGuildMemberRoleResult
} from "discord-api-types/v10";





class GuildMethods {








	public constructor(public requestHandler: RH) {}














	public async getGuild(guildId: string, withCounts?: boolean): Promise<RESTGetAPIGuildResult> {
		return this.requestHandler.request(Endpoints.GUILD(guildId), { with_counts: withCounts }, "get", "json");
	}











	public async getGuildPreview(guildId: string): Promise<RESTGetAPIGuildPreviewResult> {
		return this.requestHandler.request(Endpoints.GUILD_PREVIEW(guildId), {}, "get", "json");
	}




















	public async updateGuild(guildId: string, data: RESTPatchAPIGuildJSONBody): Promise<RESTPatchAPIGuildResult> {
		return this.requestHandler.request(Endpoints.GUILD(guildId), {}, "patch", "json", data);
	}















	public async deleteGuild(guildId: string): Promise<RESTDeleteAPIGuildResult> {
		return this.requestHandler.request(Endpoints.GUILD(guildId), {}, "delete", "json") as RESTDeleteAPIGuildResult;
	}













	public async getGuildChannels(guildId: string): Promise<RESTGetAPIGuildChannelsResult> {
		return this.requestHandler.request(Endpoints.GUILD_CHANNELS(guildId), {}, "get", "json");
	}
























	public async createGuildChannel(guildId: string, data: RESTPostAPIGuildChannelJSONBody): Promise<RESTPostAPIGuildChannelResult> {
		return this.requestHandler.request(Endpoints.GUILD_CHANNELS(guildId), {}, "post", "json", data);
	}


















	public async updateChannelPositions(guildId: string, data: RESTPatchAPIGuildChannelPositionsJSONBody, reason?: string): Promise<RESTPatchAPIGuildChannelPositionsResult> {
		return this.requestHandler.request(Endpoints.GUILD_CHANNELS(guildId), {}, "patch", "json", data, reason ? { "X-Audit-Log-Reason": reason } : undefined) as RESTPatchAPIGuildChannelPositionsResult;
	}











	public async listActiveThreads(guildId: string): Promise<RESTGetAPIGuildThreadsResult> {
		return this.requestHandler.request(Endpoints.GUILD_THREADS_ACTIVE(guildId), {}, "get", "json");
	}














	public async getGuildMember(guildId: string, memberId: string): Promise<RESTGetAPIGuildMemberResult> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBER(guildId, memberId), {}, "get", "json");
	}



















	public async getGuildMembers(guildId: string, options?: RESTGetAPIGuildMembersQuery): Promise<RESTGetAPIGuildMembersResult> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBERS(guildId), options, "get", "json");
	}













	public async searchGuildMembers(guildId: string, options: RESTGetAPIGuildMembersSearchQuery): Promise<RESTGetAPIGuildMembersSearchResult> {
		if (options.limit !== undefined && (options.limit < Constants.SEARCH_MEMBERS_MIN_RESULTS || options.limit > Constants.SEARCH_MEMBERS_MAX_RESULTS)) throw new RangeError(`Limit for searching guild members has to be between ${Constants.SEARCH_MEMBERS_MIN_RESULTS} and ${Constants.SEARCH_MEMBERS_MAX_RESULTS}`);
		return this.requestHandler.request(Endpoints.GUILD_MEMBERS_SEARCH(guildId), options, "get", "json");
	}



























	public async addGuildMember(guildId: string, memberId: string, data: RESTPutAPIGuildMemberJSONBody): Promise<RESTPutAPIGuildMemberResult> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBER(guildId, memberId), {}, "put", "json", data);
	}



























	public async updateGuildMember(guildId: string, memberId: string, data: RESTPatchAPIGuildMemberJSONBody): Promise<RESTPatchAPIGuildMemberResult> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBER(guildId, memberId), {}, "patch", "json", data);
	}




















	public async updateSelf(guildId: string, data: RESTPatchAPICurrentGuildMemberJSONBody & { reason?: string; }): Promise<APIGuildMember> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBER(guildId, "@me"), {}, "patch", "json", data);
	}



















	public async addGuildMemberRole(guildId: string, memberId: string, roleId: string, reason?: string): Promise<RESTPutAPIGuildMemberRoleResult> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBER_ROLE(guildId, memberId, roleId), {}, "put", "json", { reason }) as RESTPutAPIGuildMemberRoleResult;
	}



















	public async removeGuildMemberRole(guildId: string, memberId: string, roleId: string, reason?: string): Promise<RESTDeleteAPIGuildMemberRoleResult> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBER_ROLE(guildId, memberId, roleId), {}, "delete", "json", { reason }) as RESTDeleteAPIGuildMemberRoleResult;
	}


















	public async removeGuildMember(guildId: string, memberId: string, reason?: string): Promise<RESTDeleteAPIGuildMemberResult> {
		return this.requestHandler.request(Endpoints.GUILD_MEMBER(guildId, memberId), {}, "delete", "json", { reason }) as RESTDeleteAPIGuildMemberResult;
	}
















	public async getGuildBans(guildId: string, options?: RESTGetAPIGuildBansQuery): Promise<RESTGetAPIGuildBansResult> {
		return this.requestHandler.request(Endpoints.GUILD_BANS(guildId), options, "get", "json");
	}


















	public async getGuildBan(guildId: string, memberId: string): Promise<RESTGetAPIGuildBanResult> {
		return this.requestHandler.request(Endpoints.GUILD_BAN(guildId, memberId), {}, "get", "json");
	}






















	public async createGuildBan(guildId: string, memberId: string, data?: RESTPutAPIGuildBanJSONBody & { reason?: string; }): Promise<RESTPutAPIGuildBanResult> {
		return this.requestHandler.request(Endpoints.GUILD_BAN(guildId, memberId), {}, "put", "json", data) as RESTPutAPIGuildBanResult;
	}


















	public async removeGuildBan(guildId: string, memberId: string, reason?: string): Promise<RESTDeleteAPIGuildBanResult> {
		return this.requestHandler.request(Endpoints.GUILD_BAN(guildId, memberId), {}, "delete", "json", { reason }) as RESTDeleteAPIGuildBanResult;
	}















	public async getGuildRoles(guildId: string): Promise<RESTGetAPIGuildRolesResult> {
		return this.requestHandler.request(Endpoints.GUILD_ROLES(guildId), {}, "get", "json");
	}





















	public async createGuildRole(guildId: string, data?: RESTPostAPIGuildRoleJSONBody & { reason?: string; }): Promise<RESTPostAPIGuildRoleResult> {
		return this.requestHandler.request(Endpoints.GUILD_ROLES(guildId), {}, "post", "json", data);
	}

















	public async updateGuildRolePositions(guildId: string, data: RESTPatchAPIGuildRolePositionsJSONBody, reason?: string): Promise<RESTPatchAPIGuildRolePositionsResult> {
		return this.requestHandler.request(Endpoints.GUILD_ROLES(guildId), {}, "patch", "json", data, reason ? { "X-Audit-Log-Reason": reason } : undefined);
	}




















	public async updateGuildRole(guildId: string, roleId: string, data: RESTPatchAPIGuildRoleJSONBody): Promise<RESTPatchAPIGuildRoleResult> {
		return this.requestHandler.request(Endpoints.GUILD_ROLE(guildId, roleId), {}, "patch", "json", data);
	}


















	public async removeGuildRole(guildId: string, roleId: string, reason?: string): Promise<RESTDeleteAPIGuildRoleResult> {
		return this.requestHandler.request(Endpoints.GUILD_ROLE(guildId, roleId), {}, "delete", "json", { reason }) as RESTDeleteAPIGuildRoleResult;
	}
















	public async getGuildPruneCount(guildId: string, options?: RESTGetAPIGuildPruneCountQuery): Promise<RESTGetAPIGuildPruneCountResult> {
		return this.requestHandler.request(Endpoints.GUILD_PRUNE(guildId), options, "get", "json");
	}
















	public async startGuildPrune(guildId: string, data: RESTPostAPIGuildPruneJSONBody & { computer_prune_count: true; reason?: string; }): Promise<RESTPostAPIGuildPruneResult & { pruned: number; }>
	public async startGuildPrune(guildId: string, data: RESTPostAPIGuildPruneJSONBody & { computer_prune_count: false; reason?: string; }): Promise<RESTPostAPIGuildPruneResult & { pruned: null; }>
	public async startGuildPrune(guildId: string, data: RESTPostAPIGuildPruneJSONBody & { reason?: string; }): Promise<RESTPostAPIGuildPruneResult> {
		return this.requestHandler.request(Endpoints.GUILD_PRUNE(guildId), {}, "post", "json", data);
	}











	public async getGuildVoiceRegions(guildId: string): Promise<RESTGetAPIGuildVoiceRegionsResult> {
		return this.requestHandler.request(Endpoints.GUILD_VOICE_REGIONS(guildId), {}, "get", "json");
	}















	public async getGuildInvites(guildId: string): Promise<RESTGetAPIGuildInvitesResult> {
		return this.requestHandler.request(Endpoints.GUILD_INVITES(guildId), {}, "get", "json");
	}















	public async getGuildIntegrations(guildId: string): Promise<RESTGetAPIGuildIntegrationsResult> {
		return this.requestHandler.request(Endpoints.GUILD_INTEGRATIONS(guildId), {}, "get", "json");
	}

















	public async removeGuildIntegration(guildId: string, integrationId: string, reason?: string): Promise<RESTDeleteAPIGuildIntegrationResult> {
		return this.requestHandler.request(Endpoints.GUILD_INTEGRATION(guildId, integrationId), {}, "delete", "json", { reason }) as RESTDeleteAPIGuildIntegrationResult;
	}















	public async getGuildWidgetSettings(guildId: string): Promise<RESTGetAPIGuildWidgetSettingsResult> {
		return this.requestHandler.request(Endpoints.GUILD_WIDGET_SETTINGS(guildId), {}, "get", "json");
	}

















	public async updateGuildWidgetSettings(guildId: string, data: Partial<RESTPatchAPIGuildWidgetSettingsJSONBody & { reason?: string }>): Promise<RESTPatchAPIGuildWidgetSettingsResult> {
		return this.requestHandler.request(Endpoints.GUILD_WIDGET_SETTINGS(guildId), {}, "patch", "json", data);
	}











	public async getGuildWidget(guildId: string): Promise<APIGuildWidget> {
		return this.requestHandler.request(Endpoints.GUILD_WIDGET(guildId), {}, "get", "json");
	}















	public async getGuildVanityURL(guildId: string): Promise<RESTGetAPIGuildVanityUrlResult> {
		return this.requestHandler.request(Endpoints.GUILD_VANITY(guildId), {}, "get", "json");
	}















	public async getGuildWelcomeScreen(guildId: string): Promise<RESTGetAPIGuildWelcomeScreenResult> {
		return this.requestHandler.request(Endpoints.GUILD_WELCOME_SCREEN(guildId), {}, "get", "json");
	}

















	public async editGuildWelcomeScreen(guildId: string, data: RESTPatchAPIGuildWelcomeScreenJSONBody & { reason?: string; }): Promise<RESTPatchAPIGuildWelcomeScreenResult> {
		return this.requestHandler.request(Endpoints.GUILD_WELCOME_SCREEN(guildId), {}, "patch", "json", data);
	}


















	public async updateCurrentUserVoiceState(guildId: string, data: RESTPatchAPIGuildVoiceStateCurrentMemberJSONBody): Promise<RESTPatchAPIGuildVoiceStateCurrentMemberResult> {
		return this.requestHandler.request(Endpoints.GUILD_VOICE_STATE_USER(guildId, "@me"), {}, "patch", "json", data) as RESTPatchAPIGuildVoiceStateCurrentMemberResult;
	}


















	public async updateUserVoiceState(guildId: string, userId: string, data: RESTPatchAPIGuildVoiceStateUserJSONBody): Promise<RESTPatchAPIGuildVoiceStateUserResult> {
		return this.requestHandler.request(Endpoints.GUILD_VOICE_STATE_USER(guildId, userId), {}, "patch", "json", data) as RESTPatchAPIGuildVoiceStateUserResult;
	}
}

export = GuildMethods;





